<template>
	<div v-if="isLoaded && productsData.length" class="container-fluid overflow-hidden recommended_products">

		<div class="recommended_products_header font-responsive w-5/6 mobile:w-full mx-auto">
			<h2 class="section-heading">{{ i18n.recommended_products }}</h2>
			<!-- <slot name="subheader"></slot> -->
			<a target="_blank" class="btn-category" :href="listingUrl">{{ i18n.see_all_recommended }}</a>
		</div>
		<div class="row">
			<div class="d-none d-md-block col-md-1 col-lg-2 side-nav side-nav--left">
				<!-- LEFT NAV -->
				<ul>
					<li>
						<button @click.prevent="setCurrentPointer(calculatePointer(-1, mainProductPointer))">
							<!-- <img src="https://data.amica.com.pl/files/images/products/9236/1100431_DIM638ACNBTLRKD.jpg" class="img-fluid" alt=""> -->
							<img :src="getProductMainPhotoUrlByPointer(previousProductPointer)" class="img-fluid"
								alt="">
						</button>
					</li>
				</ul>
			</div>

			<div class="col-12 col-md-10 col-lg-8 col-xl-6 main-product">
				<!-- MAIN PRODUCT -->
				<div class="row overflow-hidden">
					<div class="col-12 col-md-5 col-xl-5">
						<!-- MAIN PRODUCT INFO -->
						<a target="_blank" :href="getMainProducCardUrl()"><span
								class="main-product__name">{{ mainProduct.prodName }}</span></a>
						<a target="_blank" :href="getMainProducCardUrl()"><span
								class="main-product__symbol">{{ mainProduct.prodSymbol }}</span></a>
                        
                        <ul
                            v-if="
                              mainProduct.attrFeaturedDataList &&                              
                                mainProduct.attrFeaturedDataList.attributeData.length
                            "
                            class="main-product__functions-list"
                          >
                            <template v-for="attribute in mainProduct.attrFeaturedDataList.attributeData">
                              <li
                                v-if="attribute != null"
                                v-bind:key="
                                  'highlighted_attribute_' + mainProduct.prodID + '_' + attribute.attrID
                                "
                              >
                                {{ highlightedAttribute(attribute) }}
                              </li>
                            </template>
                          </ul>
        
                                

						<span class="main-product__fn-heading">{{ i18n.chosen_functions }}</span>
						<div class="main-product__fn-list">
							<div v-for="(prodFn, index) in getMainProductFunctions" v-bind:key="prodFn.descID"
								class="fn-list__single-function" :class="'function-' + index">
								<h4 @click.prevent="toggleFunctionVisibility('function-' + index)"
									:class="{ 'expanded' : isFunctionVisible('function-' + index) }">
									{{ prodFn.descTitle }}</h4>
								<div class="row single-function__details"
									:class="{ 'single-function__details--expanded' : isFunctionVisible('function-' + index) }">
									<div class="col-sm-4">
										<img :src="prodFn.descIconUrl" alt="" class="img-fluid single-function__icon" />
									</div>
									<div class="col-sm-8">
										<p v-html="prodFn.descText"></p>
									</div>
								</div>
							</div>
						</div>
                        <a v-if="showBuybox" :data-ean="productsData[mainProductPointer].prodEAN" class="cc-fi-button buy-online" href="#" id="element">
                        <svg
                            v-if="widgetVisible !==true"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="34px"
                            height="31px"
                            viewBox="196.042 229.698 34 31"
                            enable-background="new 196.042 229.698 34 31"
                            xml:space="preserve"
                          >
                            <g transform="translate(0,-288.53332)">
                              <path
                                fill="#fff"
                                d="M196.741,518.231c-0.932-0.004-0.932,1.419,0,1.414h3.511c0.895,0,1.684,0.583,1.962,1.456l4.743,14.853
                            l-2.266,1.609c-0.614,0.437-1.034,1.163-1.034,2.017v0.135c0,1.353,1.095,2.465,2.425,2.465h23.204
                            c1.007,0.092,1.007-1.495,0-1.403h-23.204c-0.582,0-1.045-0.471-1.045-1.062v-0.135c0-0.293,0.264-0.73,0.452-0.864l2.558-1.819
                            h16.634c0.896,0,1.689-0.588,1.965-1.456l3.243-10.214c0.427-1.344-0.584-2.765-1.973-2.765h-20.105
                            c-1.007-0.091-1.007,1.496,0,1.403h20.105c0.483,0,0.803,0.449,0.652,0.925l-0.602,1.893h-17.446
                            c-0.927,0.048-0.854,1.463,0.073,1.414h16.924l-0.896,2.82h-13.326c-0.852,0.109-0.787,1.384,0.07,1.403h12.813l-0.853,2.683
                            c-0.094,0.294-0.346,0.49-0.645,0.49h-16.42l-4.726-14.831c-0.462-1.445-1.792-2.432-3.284-2.432L196.741,518.231z"
                              />
                              <path
                                fill="#fff"
                                d="M209.9,543.595c-1.523,0-2.773,1.271-2.773,2.818s1.25,2.818,2.773,2.818c1.522,0,2.763-1.271,2.763-2.818
                            C212.661,544.865,211.422,543.595,209.9,543.595L209.9,543.595z M209.9,544.998c0.773,0,1.381,0.628,1.381,1.415
                            s-0.607,1.404-1.381,1.404c-0.774,0-1.392-0.617-1.392-1.404S209.126,544.998,209.9,544.998z"
                              />
                              <path
                                fill="#fff"
                                d="M223.752,543.595c-1.522,0-2.772,1.271-2.772,2.818s1.25,2.818,2.772,2.818s2.772-1.271,2.772-2.818
                            S225.275,543.595,223.752,543.595z M223.752,544.998c0.773,0,1.392,0.628,1.392,1.415s-0.618,1.404-1.392,1.404
                            s-1.381-0.617-1.381-1.404S222.979,544.998,223.752,544.998z"
                              />
                            </g>
                          </svg>
							{{ i18n.buy_online }}
						</a>
					</div>
					<div class="col-12 col-md-7 col-xl-7 main-product_main-photo-cnt">
						<!-- MAIN PRODUCT IMAGE -->
						<button class="main-product__nav main-product__nav--left"
							@click.prevent="movePointer(-1)"></button>
						<a target="_blank" :href="getMainProducCardUrl()">
							<img class="main-product__main-photo"
								:src="getProductMainPhotoUrlByPointer(this.mainProductPointer)" alt="" />
						</a>
						<button class="main-product__nav main-product__nav--right"
							@click.prevent="movePointer(1)"></button>
					</div>
				</div>
			</div>

			<div class="d-none d-md-block col-md-1 col-lg-2 col-xl-4 side-nav side-nav--right">
				<!-- RIGHT NAV -->
				<ul>
					<li v-for="prodPointer in remainingProductsPointers" v-bind:key="prodPointer">
						<button @click.prevent="setCurrentPointer(prodPointer)">
							<img :src="getProductMainPhotoUrlByPointer(prodPointer)" class="img-fluid" alt="">
						</button>
					</li>
				</ul>
			</div>

		</div>
	</div>
</template>

<script>
import axios from "axios";
import slug from "slug";

export default {
  data() {
    return {
      isLoaded: false,
      mainProductPointer: 0,
      widgetVisible:false,
      buybox: {
        isLoading: false,
        isOpened: false,
        currentShopsList: [],
      },
      functionVisibility: {
        "function-0": false,
        "function-1": false,
        "function-2": false,
      },
    };
  },
  props: {
    component_data: {
      default: () => [],
    },
  },
  methods: {
    dataLayer: function(shop) {
      let cmp = this;
      window.dataLayer.push({
        event: "shopClick",
        eventType: "Produkty polecane",
        click_productName: cmp.productsData[cmp.mainProductPointer].prodSymbol,
        click_productId: cmp.productsData[cmp.mainProductPointer].prodID,
        click_productCategory:
          cmp.productsData[cmp.mainProductPointer].prodCategoryData.catName,
        click_productSubcategory:
          cmp.productsData[cmp.mainProductPointer].prodCategoryData.catMenu,
        click_shopName: shop,
      });
    },
    //@ moveBy = 1 || -1
    movePointer: function(moveBy) {
      let newPointer = this.calculatePointer(moveBy);
      this.mainProductPointer = newPointer;

      this.functionVisibility["function-0"] = false;
      this.functionVisibility["function-1"] = false;
      this.functionVisibility["function-2"] = false;
    },
    //@ moveBy = 1 || -1
    //@ pointer = względem jakiego pointera, jeśli null to current
    calculatePointer: function(moveBy, pointer = null) {
      let allProductsLength = this.productsData.length;
      let currentPointer = pointer || this.mainProductPointer;
      let newPointer = currentPointer + moveBy;
      if (newPointer < 0) {
        return allProductsLength - 1;
      }
      if (newPointer > allProductsLength - 1) {
        return newPointer % allProductsLength;
      }
      return newPointer;
    },
    getProductMainPhotoUrlByPointer: function(pointer) {
      let prodId = this.productsData[pointer].prodID;
      if (prodId) {
        return this.baseUrl + "produkt/zdjecie/" + prodId + "/320";
      }
    },
    setCurrentPointer: function(pointer) {
      this.mainProductPointer = pointer;
    },
    openBuybox: function() {
      let cmp = this;
      let prodEAN = cmp.productsData[cmp.mainProductPointer].prodEAN;
      cmp.buybox.kodEan = cmp.productsData[cmp.mainProductPointer].prodEAN;
      console.log(
        (cmp.buybox.kodEan = cmp.productsData[cmp.mainProductPointer].prodEAN)
      );
      if (prodEAN) {
        cmp.buybox.isLoading = true;
        axios
          .get(
            cmp.baseUrl +
              "SoapProducts/getOnlineShopsAjax/prodEan:" +
              prodEAN +
              ".json"
          )
          .then((r) => {
            //let responseData = r.data
            cmp.buybox.currentShopsList = [];
            r.data.forEach((shop) => {
              cmp.buybox.currentShopsList.push(shop);
            });
            cmp.buybox.isOpened = true;
          });
      }
    },
    closeBuybox: function() {
      this.buybox.isLoading = false;
      this.buybox.isOpened = false;
      this.buybox.currentShopsList = [];
    },
    toggleFunctionVisibility: function(id) {
      let cmp = this;
      let a = ["function-0", "function-1", "function-2"];
      a.forEach((el) => {
        if (el === id) {
          cmp.functionVisibility[el] = !cmp.functionVisibility[el];
        } else {
          cmp.functionVisibility[el] = false;
        }
      });
    },
    isFunctionVisible: function(id) {
      return this.functionVisibility[id];
    },
    getMainProducCardUrl: function() {
      let cmp = this;
      let product = cmp.productsData[cmp.mainProductPointer];
      let prodId = product.prodID;
      let prodName = product.prodName;
      let prodSymbol = product.prodSymbol;
      return (
        this.productBaseUrl +
        prodId +
        "-" +
        slug(prodName, "_") +
        "--" +
        slug(prodSymbol, "_")
      );
    },
    highlightedAttribute: function(attribute) {
      if (attribute.attrName && attribute.attrValue) {
        return attribute.attrName + " " + attribute.attrValue;
      } else if (attribute.attrValue) {
        return attribute.attrValue;
      }
    },
  },
  computed: {
    i18n() {
       if (window.pageContentData) {
        return window.pageContentData.params.i18n;
      }
  
      return {
        buy_online: "Kup online",
        buybox_copy: "Sklepy internetowe, w których kupisz ten produkt",
        chosen_functions: "Wybrane funkcje",
        close: "Zamknij",
        recommended_products: "Produkty polecane",
        see_all_recommended: "Zobacz wszystkie produkty"
      };
  
    },
    showBuybox() {
      if (window.pageContentData.params.noBuybox) {
        return false;
      }
      return true;
    },
    listingUrl: function() {
    if (this.component_data.listingUrl) {
      return this.component_data.listingUrl
    } else { 
    return window.pageContentData.params.listingUrl
    }
    },
   
    
    productBaseUrl: function() {
      if (window.pageContentData.params.productRelativeUrl) {
        return (
          this.baseWithLangUrl +
          window.pageContentData.params.productRelativeUrl
        );
      }
      return this.baseWithLangUrl + "produkty/produkt/";
    },
    baseWithLangUrl() {
      if (window.pageContentData.params.baseWithLangUrl) {
        return window.pageContentData.params.baseWithLangUrl;
      }
      return this.baseUrl;
    },
    baseUrl() {
      if (window.pageContentData.params.base) {
        return window.pageContentData.params.base;
      }
      return "https://www.amica.pl/";
    },
        // zwraca listę produktów polecanych ustawionych dla komponentu lub w głównej tablicy parametrów lp'ka
    productsData() {
      let products = [];
      if (this.component_data.recommendedProducts && this.component_data.recommendedProducts.length ) {
        products = this.component_data.recommendedProducts;
      } else if (window.pageContentData) {
        products = window.pageContentData.params.recommendedProducts;
      }
      if (products.length <= 3) {
        return products.concat(products);
      }
      return products;
    },
    // zwraca dane o głównym produkcie
    mainProduct: function() {
      return this.productsData[this.mainProductPointer];
    },
    // zwraca wskaźnik do produktu poprzedniego (względem głównego)
    previousProductPointer: function() {
      return this.calculatePointer(-1);
    },
    // zwraca tablice wskaźników do pozostałych produktów w kolejności od n+1 do n-2 (poza głównym=n i poprzednim=n-1)
    remainingProductsPointers: function() {
      let nextPointers = [];
      for (let i = 0; i < this.productsData.length - 2; i++) {
        nextPointers.push(
          this.calculatePointer(1, this.mainProductPointer + i)
        );
      }
      return nextPointers;
    },
    getMainProductFunctions: function() {
      let cmp = this;
      let pickedFunctions = [];
      cmp.mainProduct.pickedDescriptions.forEach((el) => {
        let fnc = cmp.mainProduct.prodDescriptionDataList.prodDescriptionData.find(
          (fn) => {
            return fn.descID == el;
          }
        );
        if (fnc) pickedFunctions.push(fnc);
      });
      return pickedFunctions;

      // return this.mainProduct.prodDescriptionDataList.prodDescriptionData.filter(d => {
      //   return this.mainProduct.pickedDescriptions.indexOf(d.descID) > -1
      // })
    },
  },
  mounted() {
    this.isLoaded = true;
    window.dataLayer = window.dataLayer || [];
  },
};
</script>

<style>
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
</style>

<style lang="scss" scoped>
// font-family: 'Lato', sans-serif;
// font-family: 'Uni Neue', sans-serif;
.recommended_products {
  position: relative;
}

.recommended_products_header {
  display: flex;
  align-items: center;

  .btn-category {
    text-transform: uppercase;
    color: #fff;
    padding: 1em 1.7em;
    border-radius: 10px;
    font-size: 1.4em;
    display: inline-block;
    background: #e41429;
    background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: -webkit-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: linear-gradient(to right, #e41429 0%, #ae0b11 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e41429', endColorstr='#ae0b11', GradientType=1);

    &:hover {
      text-decoration: none;
    }
  }
}
@media (max-width: 768px) {
  .recommended_products{
    padding-top:10px;
  }
.recommended_products_header{
  margin-bottom: -100px;
}
}
.section-heading {
  font-size: 4.2em;
  margin: 1em auto 1em 0;
  color: #e41429;
  font-weight: 700;
  font-family: "Uni Neue", sans-serif;
}

.main-product {
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: "Lato", sans-serif;

  & > .row {
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  .main-product__name {
    width: 100%;
    display: inline-block;
    color: #333;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .main-product__symbol {
    width: 100%;
    display: inline-block;
    font-family: "Uni Neue", sans-serif;
    font-weight: 400;
    color: #27241d;
    font-size: 28px;
    line-height: 32px;
  }
  
  .main-product__functions-list {
    margin-bottom: 1rem;
    margin-top: 1rem;
    list-style-position: inside;
    padding-left: 0px;
    color: #585858;    
  }

  .buy-online {
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    padding: 14px 30px 14px 38px;
    display: inline-block;
    margin-top: 35px;
    margin-bottom: 35px;
    border-radius: 10px;

    background: #e41429;
    background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: -webkit-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: linear-gradient(to right, #e41429 0%, #ae0b11 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e41429', endColorstr='#ae0b11', GradientType=1);

    -webkit-box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);
    -moz-box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.14);

    svg {
      top: -2px;
      left: -10px;
      position: relative;
      width: 20px;

      .a {
        fill: #fff;
      }
    }

    &:hover {
      text-decoration: none;
    }
  }

  .main-product__fn-heading {
    font-family: "Uni Neue", sans-serif;
    color: #b8b2a7;
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    display: inline-block;
    margin-bottom: 5px;
    text-transform: uppercase;
  }

  .main-product__fn-list {
    .fn-list__single-function {
      border-bottom: 1px #d0d1d1 solid;
      padding: 12px 0 16px 0;

      h4 {
        color: #333;
        font-size: 20px;
        margin-bottom: 0px;
        line-height: 24px;
        padding-right: 30px;
        position: relative;
        cursor: pointer;

        &:before {
          content: "";
          width: 2px;
          height: 8px;
          background: #d0d1d1;
          position: absolute;
          right: 10px;
          top: 50%;
          transform: rotate(45deg);
        }

        &:after {
          content: "";
          width: 2px;
          height: 8px;
          background: #d0d1d1;
          position: absolute;
          right: 14px;
          top: 50%;
          transform: rotate(-45deg);
        }

        &.expanded {
          &:before {
            transform: rotate(-45deg);
          }

          &:after {
            transform: rotate(45deg);
          }
        }
      }

      .single-function__details {
        display: none;
        margin-top: 20px;

        -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
        transition: all 0.1s ease-in-out;

        &.single-function__details--expanded {
          display: flex;
        }

        p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 0px;
        }

        .single-function__icon {
          margin-top: 10px;

          @media only screen and (max-width: 768px) {
            margin-bottom: 10px;
          }
        }
      }
    }

    // li {
    //   max-width: 33%;
    //   width: 80px;
    //   display: inline-block;
    //   margin-right: 20px;
    //   vertical-align: top;
    //   margin-bottom: 10px;

    //   &:last-child {
    //     margin-right: 0px;
    //   }

    //   img {
    //     margin-bottom: 10px;
    //   }

    //   span {
    //     font-size: 12px;
    //     color: #E41429;
    //     line-height: 16px;
    //     text-align: center;
    //     display: inline-block;
    //     width: 100%;
    //     vertical-align: top;
    //   }
    // }
  }

  .main-product_main-photo-cnt {
    padding-bottom: 70px;
    min-height: 500px;

    @media only screen and (max-width: 768px) {
      // overflow: hidden;
    }
  }

  .main-product__main-photo {
    max-width: 72%;
    max-height: 380px;
    display: block;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;

    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) mtranslateY(-50%);
    transform: translateX(-50%) translateY(-50%);

    @media only screen and (max-width: 1570px) {
      max-width: 70%;
    }

    @media only screen and (max-width: 1450px) {
      max-width: 65%;
    }
  }

  .main-product__nav {
    width: 40px;
    height: 40px;
    position: absolute;
    border: 2px #b8b2a7 solid;
    border-radius: 99px;
    background: #fff url("../../assets/nav-arrow.svg") no-repeat;
    background-position: 45% 50%;
    cursor: pointer;

    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;

    &.main-product__nav--left {
      top: calc(50% - 70px);
      left: 5%;

      @media only screen and (max-width: 768px) {
        top: auto;
        bottom: 20px;
        left: 25%;
      }
    }

    &.main-product__nav--right {
      transform: rotate(180deg);
      top: calc(50% - 70px);
      right: 5%;

      @media only screen and (max-width: 768px) {
        bottom: 20px;
        top: auto;
        right: 25%;
      }
    }

    &:hover {
      border: 4px #e41429 solid;
    }

    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}

.side-nav {
  margin-top: -40px;

  ul {
    padding-left: 0px;
    margin-bottom: 0px;
    list-style: none;
    position: absolute;
    top: 50%;
    width: 20000%;

    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);

    li {
      width: 200px;
      display: inline-block;
      margin-right: 40px;

      button {
        border: none;
        cursor: pointer;
        background: none;
        width: 100%;

        img {
          opacity: 0.4;
        }

        &:focus,
        &:active {
          outline: none;
          box-shadow: none;
        }
      }
    }
  }

  &.side-nav--left {
    ul {
      left: -30px;

      @media only screen and (max-width: 992px) {
        left: calc(-20000% + 90px);
        text-align: right;
      }
    }
  }

  &.side-nav--right {
  }
}

.buybox-container {
  position: absolute;
  width: 100%;
  height: calc(100% + 70px);
  top: calc(-100% - 70px);
  left: 0px;

  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;

  @media only screen and (max-width: 767px) {
    width: 98vw;
    left: -98%;
  }

  &.buybox-container--loading {
    top: calc(-100% + 70px);
    // opacity: 1;
  }

  &.buybox-container--opened {
    top: 0px;
    left: 0;
    // opacity: 1;
  }

  .buybox-container__content {
    width: 100%;
    height: calc(100% - 140px);
    background: #fff;
    padding: 20px;
    border: 2px #e41429 solid;
    border-bottom: none;
    -webkit-border-top-left-radius: 10px;
    -webkit-border-top-right-radius: 10px;
    -moz-border-radius-topleft: 10px;
    -moz-border-radius-topright: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    h3 {
      font-size: 16px;
      font-weight: 400;
      width: 100%;
      text-align: center;
      text-transform: uppercase;
    }

    ul {
      padding-left: 0px;
      margin-bottom: 0px;
      list-style: none;
      margin-top: 40px;

      -moz-column-count: 2;
      -moz-column-gap: 20px;
      -webkit-column-count: 2;
      -webkit-column-gap: 20px;
      column-count: 2;
      column-gap: 20px;

      li {
        text-align: center;
        margin-bottom: 20px;
      }
    }
  }

  .buybox-container__loader {
    width: 100%;
    height: 70px;
    position: relative;

    background: #e41429;
    background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: -webkit-linear-gradient(left, #e41429 0%, #ae0b11 100%);
    background: linear-gradient(to right, #e41429 0%, #ae0b11 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e41429', endColorstr='#ae0b11', GradientType=1);

    -webkit-border-bottom-left-radius: 10px;
    -webkit-border-bottom-right-radius: 10px;
    -moz-border-radius-bottomleft: 10px;
    -moz-border-radius-bottomright: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    .loader {
      position: relative;
      top: 23px;
    }

    button {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      font-size: 16px;
      color: #fff;
      font-weight: 500;
      border: none;
      background: transparent;
      // margin-top: 20px;
      background: transparent;
      cursor: pointer;
      text-transform: uppercase;

      span.btn-close {
        width: 30px;
        height: 30px;
        display: inline-block;
        border: 2px #fff solid;
        border-radius: 99px;
        margin-right: 10px;
        vertical-align: middle;
        background: url("../../assets/btn_close.svg");
        background-position: 50% 50%;
        margin-top: -2px;
      }
    }
  }
}

.empty-buybox-list {
  text-align: center;
  font-size: 14px;
  margin-top: 30px;
  text-transform: uppercase;
}
</style>
